import axios from 'axios';

export const getAllConfigList = scope =>
  (scope ? axios.get('/config/all/list/', { params: { scope } }) : axios.get('/config/all/list/')).then(
    response => response.data
  );

// 获取单个配置信息的API函数
export const getConfigSetting = slug => axios.get(`/config/setting/${slug}/`).then(response => response.data);

// 更新配置设置的API函数
export const updateConfigSetting = (slug, data) =>
  axios.post(`/config/setting/${slug}/`, data).then(response => response.data);
